import BaseService from "./BaseService";

class EmailService extends BaseService {

    async sendEmail(req) {
        const response = await this.axios.post('/email/send', req);
        return await response.data;
    }
}
export default EmailService